import { render, staticRenderFns } from "./ProcessedDocumentsList.vue?vue&type=template&id=9976b6c6"
import script from "./ProcessedDocumentsList.vue?vue&type=script&lang=ts"
export * from "./ProcessedDocumentsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports